/**
 * External dependencies
 */
import '@fancyapps/fancybox';
/**
 * Internal dependencies
 */
import './front.styl';

jQuery(document).ready(() => {
	function extractImageSizes(srcSet) {
		const sources = srcSet.split(',');
		const sizes = sources.map((item) => parseInt(item.match(/\d+w$/)));

		function getSourceWith(size) {
			return sources[sizes.indexOf(size)].replace(/\d+w$/, '').trim();
		}

		return {
			min: getSourceWith(Math.min(...sizes)),
			max: getSourceWith(Math.max(...sizes)),
		};
	}

	jQuery('.wp-block-image, .news__thumbnail')
		.not('.wp-block-gallery .wp-block-image')
		.on('click', (e) => {
			const image = e.currentTarget.querySelector('img');
			const caption = e.currentTarget.querySelector('figcaption');

			const fancyboxOptions = {
				src: image.src,
				opts: {
					caption: caption ? caption.innerText : '',
				},
			};

			if ('' !== image.srcset) {
				const sizes = extractImageSizes(image.srcset);
				fancyboxOptions.opts.thumb = sizes.min;
			}

			jQuery.fancybox.open([fancyboxOptions]);
		});

	jQuery('.wp-block-gallery').on('click', (e) => {
		const $gallery = jQuery(e.target).parents().eq(2);
		const $items = $gallery.find(
			'.blocks-gallery-item img, .wp-block-image img'
		);
		const items = [];
		let clickedItem = e.target;
		let indexItem = 0;

		for (const item of $items) {
			let fancyboxOptions = {
				src: item.src,
			};

			if ('' !== item.srcset) {
				const sizes = extractImageSizes(item.srcset);

				fancyboxOptions = {
					src: sizes.max,
					opts: {
						thumb: sizes.min,
					},
				};
			}

			items.push(fancyboxOptions);
			if (clickedItem === item) {
				clickedItem = indexItem;
			}

			indexItem++;
		}

		jQuery.fancybox.open(items, {
			index: clickedItem,
		});
	});
});
